const routesName = {
  login: "login",
  registration: "registration",
  reset: "resetPassword",
  restore: "restorePassword",
  landing: "landing",
  onboarding: "onboarding",
  onboardingStep: "onboardingStep",
  myCourses: "myCourses",
  myCertificates: "myCertificates",
  myTranscript: "myTranscript",
  myProfile: "myProfile",
  mySettings: "mySettings",
  dashboard: "dashboard",
  course: "course",
  courseFollowUp: "courseFollowUp",
  coursesList: "coursesList",
  center: "center",
  module: "module",
  centersList: "centersList",
  faq: "faq",
  contactUs: "contactUs",
  partners: "partners",
  notFound: "notFound",
  profileOnboarding: "profileOnboarding",
  confirmAccount: "confirmAccount",
  confirmAccountWithPassword: "confirmAccountWithPassword",
  specialitiesList: "specialitiesList",
  privacyPolicy: "privacyPolicy",
  terms: "terms",
};

export default routesName;
